import { INVISIBLES, stripInvisibles } from '@workspace/constants/common.constant';
import { ItemAlignment, type HeadingType, type StyledHeading } from '@workspace/interfaces';

export type { HeadingType, StyledHeading } from '@workspace/interfaces';

// For Middle Banner & Content Block only: map to Typography variant
export const mapHeadingVariant = (
  heading?: StyledHeading | string,
  fallback: 'h1' | 'h2' | 'h3' = 'h2',
): 'h1' | 'h2' | 'h3' => {

  if (!heading || typeof heading === 'string') return fallback;

  const fontSize = stripInvisibles((heading.fontSize ?? '').trim()).toLowerCase();
  if (fontSize === 'h1' || fontSize === 'h2' || fontSize === 'h3') return fontSize;
  return fallback;
};

// Generic: only return text; size styling handled per component policy
export const processHeading = (heading?: HeadingType) => {
  const text = typeof heading === 'string' ? heading : (heading?.headingText ?? '');
  return { text };
};

export const cleanTextAlign = (textAlign: string, fallback: ItemAlignment = 'left') =>
  typeof textAlign === 'string' ? textAlign.replace(INVISIBLES, '').trim() : fallback;

export const getTextAlignClasses = (textAlign: string) => {
  // Clean the textAlign string by removing invisible characters
  const cleanedTextAlign = cleanTextAlign(textAlign);

  switch (cleanedTextAlign) {
    case 'center':
      return 'text-center';
    case 'middle':
      return 'text-center';
    case 'right':
      return 'text-right';
    default:
      return 'text-left';
  }
};
